// extracted by mini-css-extract-plugin
export default {"label":"PerformanceChart_label__IwIzz","labelY":"PerformanceChart_labelY__Vz20W"};